/**
 * This simple helper converts a csv file which uses | as a separator into an array of objects where the first line of the
 * csv file is interpreted as the header. This is not sufficient for our algorithms, but it can serve as a consolidated
 * pre-processing that makes the algorithm-specific parsing simpler.
 */
export default function (csvContent) {
    console.log({
        "msg": "reading csvContent",
        "component": "csvToJson",
        "csvStart": csvContent.substring(0, Math.min(20, csvContent.length))
    })
    // 01. Split at |, but you still have the last cell of a row and the first of the next row as one "cell"
    let uncleanedCells = csvContent.split('|')
    // 02. Count how many columns it has
    let columnCount = 0
    while(uncleanedCells[columnCount].indexOf('\n') === -1) {
        columnCount++
    }
    columnCount++
    console.log({
        "msg": `counted ${columnCount} many columns`,
        "component": "csvToJson",
    })

    // 03. Split at the last linebreak of the last entry of each row again to split the last entry of a row from the first entry of the next row
    const cells = []
    let it = 0
    while(it < uncleanedCells.length) {
        if(it === 0 || it % (columnCount-1) !== 0 || it === uncleanedCells.length - 1) {
            cells.push(uncleanedCells[it])
        } else {
            const lastIndexOfLinebreak = uncleanedCells[it].lastIndexOf('\n')
            cells.push(uncleanedCells[it].substring(0, lastIndexOfLinebreak))
            cells.push(uncleanedCells[it].substring(lastIndexOfLinebreak + 1))
        }
        it++
    }

    console.log({
        "msg": `All in all, we have ${cells.length} many cells`,
        "component": "csvToJson",
    })

    // 04. Remove the "" if you have a String in the cell
    for(let i = 0; i < cells.length; i++) {
        if(cells[i].startsWith("\"") && cells[i].endsWith("\"")) {
            console.log({
                "msg": `Removing outer " from cell ${i}, since it seems to be a String (cell content: ${cells[i].substring(0,50)} ...).`,
                "component": "csvToJson"
            })
            cells[i] = cells[i].substring(1, cells[i].length - 1)
        }
    }

    // 05. Extract the header fields
    const headers = cells.slice(0, columnCount)
    console.log({
        "msg": `Extracted the headers: ${headers}`,
        "component": "csvToJson"
    })
    // 06. Split the cells into the actual rows of the table
    let jt = columnCount
    let lines = []
    while (jt < cells.length) {
        let nextLine = []
        for(let k = 0; k < columnCount; k++) {
            nextLine.push(cells[jt + k])
        }
        lines.push(nextLine)
        jt += columnCount
    }
    console.log({
        "msg": `Counted ${lines.length} many lines after the header.`,
        "component": "csvToJson"
    })

    // 07. Make actual JSON objects from the rows
    let result = []
    for (let i = 0; i < lines.length; i++) {
        let current = lines[i]
        let currResult = {}
        for (let j = 0; j < headers.length; j++) {
            currResult[headers[j]] = current[j]
        }

        result.push(currResult)
    }
    console.log({
        "msg": "created actual JSONObjects from the CSV-Rows and finished csvToJson",
        "component": "csvToJson"
    })
    return result
}